
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export async function redirectToEditor(programId: string) {
  try {
    // Get the current session
    const { data: { session }, error } = await supabase.auth.getSession();
    
    if (error) {
      console.error("Error getting session:", error);
      toast.error("Authentication error. Please try logging in again.");
      return;
    }
    
    if (!session || !session.access_token || !session.refresh_token) {
      toast.error("No valid session found. Please log in again.");
      return;
    }
    
    if (!programId) {
      toast.error("Program ID is required to edit the program.");
      return;
    }
    
    // Build the redirect URL with authentication tokens and program ID
    const editorUrl = new URL("https://edit.corva.pro");
    editorUrl.searchParams.set("access_token", session.access_token);
    editorUrl.searchParams.set("refresh_token", session.refresh_token);
    editorUrl.searchParams.set("program_id", programId);
    
    console.log("Redirecting to editor with program ID:", programId);
    
    // Perform the redirect
    window.location.href = editorUrl.toString();
  } catch (error) {
    console.error("Error redirecting to editor:", error);
    toast.error("Failed to open program editor. Please try again.");
  }
}
